export const ReturnAddressLabelDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_396_679)">
            <rect width="32" height="32" rx="4" />
            <path d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z" />
            <g opacity="0.96">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.13641 10.0769V14.0029C9.13637 14.502 9.33452 14.9807 9.68732 15.3337L16.9413 22.5883C17.3088 22.9556 17.9046 22.9556 18.2721 22.5883L22.5883 18.2714C22.9557 17.9039 22.9557 17.3081 22.5883 16.9406L15.3344 9.68666C14.9814 9.33384 14.5027 9.1357 14.0035 9.13574H10.0776C9.55779 9.13574 9.13641 9.55712 9.13641 10.0769Z"
                    stroke="#5C5C5C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.4305 13.3709C12.9503 13.3709 13.3717 12.9495 13.3717 12.4297C13.3717 11.9099 12.9503 11.4885 12.4305 11.4885C11.9107 11.4885 11.4893 11.9099 11.4893 12.4297C11.4893 12.9495 11.9107 13.3709 12.4305 13.3709Z"
                    stroke="#5C5C5C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_396_679">
                <rect width="32" height="32" rx="4" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
